import { render, staticRenderFns } from "./experts-consultants.vue?vue&type=template&id=4e84116e&scoped=true&"
import script from "./experts-consultants.vue?vue&type=script&lang=js&"
export * from "./experts-consultants.vue?vue&type=script&lang=js&"
import style0 from "./experts-consultants.vue?vue&type=style&index=0&id=4e84116e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e84116e",
  null
  
)

export default component.exports